import {Tooltip} from '@chakra-ui/react'
import {InfoIcon} from "@chakra-ui/icons";
import {useState} from 'react';

export const PmsItemTitle = ({tooltip, children, required = false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='flex items-center gap-2'>
      <span className='text-lg text-brand-text relative'>
        {children}
        {required && (
          <span className='text-red-500 superscript text-sm -right-2 absolute'>*</span>
        )}
      </span>
      {tooltip && (
        <Tooltip hasArrow label={tooltip} isOpen={isOpen}>
          <div onClick={onClick}>
            <InfoIcon color="blue.200"/>
          </div>
        </Tooltip>
      )}
    </div>
  )
};
